import React from "react";
import Modal from "react-modal";

import styles from "./modal.module.css";

Modal.setAppElement("#root");

export default function CustomModal({
  visible,
  handleClose,
  handleAfterClose,
  children,
  className,
  classNameOverlay,
}) {
  return (
    <Modal
      className={{
        base: `${styles["modal"]} ${className || ""}`,
        beforeClose: styles["beforeClose"],
      }}
      closeTimeoutMS={500}
      overlayClassName={`${styles["overlay"]} ${classNameOverlay || ""}`}
      isOpen={visible}
      onRequestClose={handleClose}
      onAfterClose={handleAfterClose}
    >
      {children}
    </Modal>
  );
}
